import type { QueryKey } from '@tanstack/react-query';
import { get } from '../../../../redux/api';
import { nuc } from '../../../../utils';
import type { SBOMAnalysis } from '../../../../../shared/sbomSummary/sbomAnalysis';
import { useQuery } from '../../../../ReactQuery';

function getSBOMAnalysis(locator: string) {
  return get<SBOMAnalysis>(`/api/revisions/${nuc(locator)}/sbom-analysis`);
}

const getQueryKey = (locator: string): QueryKey => [
  `sbom-analysis`,
  locator,
];

/**
 * Fetch a single SBOM Analysis data by SBOM Summary locator.
 *
 * @param {string} locator - The locator of the SBOM Summary to fetch
 */
export default function useSBOMAnalysis(
  locator: string,
) {
  return useQuery<SBOMAnalysis>({
    queryKey: getQueryKey(locator),
    queryFn: () => getSBOMAnalysis(locator),
    refetchInterval: (query) => {
      // Disable polling if the query is available. This means we already got the valid data from the API.
      if (query) {
        return false;
      }
      return 5000;
    },
  });
}
